import { ETRACK_DATA, GRID_ROWS_PER_PAGE } from '../../constants';

export const initialState = {
  checkedForAdd: null,
  backToSearchPayload: {
    customerId: 0,
    itemsUnassignedFlag: '',
    itemsId: 0,
    serialNumber: '',
    serviceModelId: 0,
    siteNameContains: '',
    siteId: 0,
    orderNumber: '',
    quoteId: 0,
    recordCount: GRID_ROWS_PER_PAGE.eTrackSearchSourceGrid,
    pageIndex: GRID_ROWS_PER_PAGE.initialIndex,
    eTrackSiteName: '', 
    eTrackServiceName: ''
  },
  apiQuotesResponse: {
    deleteQuote: false,
    saveQuote: false,
    submitQuote: false,
  },
  allSalesOrderItemsMustQuality: true,
  siteType: [],
  orderGroup: ETRACK_DATA.ANY,
  etrack: [],
  etrackDataFound: false,
  etrackDataFoundCount: 0,
  isEtrackLoading: false,
  isEtrackLoadingPagination: false,

  etrackAGridData: [],
  etrackBGridData: [],

  customerId: '',
  siteId: '',
  siteName: '',
  siteTypeId: 1,
  warrantyStatusId: 2,
  endOfServiceDate: null,
  daysToExpire: '',
  warrantyEndIsEosFlag: 'n',
  entitlementId: '',
  quoteId: null,
  quoteNumber: 0,
  serviceId: '',
  serviceModel: '',
  serviceProductCode: '',
  serviceProductDescription: '',
  eTrackSerailNumber: '',
  eTrackCheckBox: 'n',
  eTrachItems: 0,
  currentSerialNumber: '',
  orderNumber: '',
  shipDate: '',
  status: 'Active',
  servicePriceLevelId: 2,
  endDate: '',
  warrantyStatusCode: 'E',
  isEtrackSearchDataGridVisible: false,
  isentitlementsSearch: true,
  isentitlementsMain: false,
  siteNameContains: '',
  isSitesResultsFound: false,
  eTrackCustNo: '',
  quickEtrackCustomerNumber: '',
  quickEtrackCustomerName: '',
  quickEtrackCustomerId: '',
  eTrackSiteID: 0,
  eTrackSiteName: 0,
  //Modals
  //Site Name Modal
  siteNameModal: {
    loading: false,
    openSiteModal: false, // You can store Site modal open status here
    siteSearchData: [], // You can store the Sitesearch data here
    gridSiteRowSelectedData: [], // You can store the grid row selected data here
    gridSiteRowSelectedCount: 0, // You can store the grid rows selected count
    sites: [], // You can store the accounting groups here
    siteGridTotalRecords: 0, // You can store the total records of the grid here
    siteSearchForm: {
      name: '',
      siteId: '',
    },
  },

  eTrackServiceID: 0,
  eTrackServiceName: '',
  isServiceModalResultsFound: false,
  serviceNameModal: {
    loading: false,
    openServiceModal: false, // You can store Site modal open status here
    serviceModalSearchData: [], // You can store the Sitesearch data here
    gridServiceModalRowSelectedData: [], // You can store the grid row selected data here
    gridServiceModalRowSelectedCount: 0, // You can store the grid rows selected count
    serviceModal: [], // You can store the accounting groups here
    serviceModalGridTotalRecords: 0, // You can store the total records of the grid here
    serviceMpdalSearchForm: {
      name: '',
      erpModelId: '',
    },
  },

  checkboxState: {},
  checkboxArray:[{}],
  checkboxQuoteState: {},
  selectedData: [],
  //E-Track Quote Types
  eTrackQuoteTypes: [],
  selectedeTrackQuoteType: ETRACK_DATA.defaultETrackQuoteType,
  alertText: '',
  actionDialog: [],
  alertBoxOpen: false,
  alertBoxOpenAddItemModal: false,
  //E-Track - Create/Save/Delete/Submit New Quote
  isCreateNewQuoteLoading: false,
  createQuoteData: [],
  isCreateQuoteSuccess: false,
  quoteDetails: [],
  isSaveLoading: false,
  isDeleteLoading: false,
  isSubmitLoading: false,
  isDeleteQuoteSuccess: false,
  isSubmitQuoteSuccess: false,
  isSaveQuoteSuccess: false,
  quoteFormData: {
    custRef: null,
    description: null,
  },
  openSubmitModal: false,
  submitQuoteCommentText: null,
  isSubmitQuoteModalOpen: false,
  apiSuccessResponse: {
    get: '',
  },
  approvalByHWE: false,
  quoteDetailsForEmail: [],
  triggerSubmitted: false,
  triggerAutoApproved: false,
  quoteDetailsForEmailLoading: false,
  notificationSent: null,
  notificationSentLoading: false,
  exportResellerQuoteData: [],
  exportClientQuoteData: [],
  exportClientLoading: false,
  exportResellerLoading: false,
  eTrackOrigin: '',
  //Add Items Modal
  addItemsModalOpen: false,
  //Quote Detail Grid
  selectedQuoteDetailGridData: [],
  alertBoxOpenQuoteDetail: false,
  alertTextQuoteDetail: '',
  updateQuoteItemData: {
    entitlementId: 0,
    entitlementQuoteId: 0,
    userId: 0,
    extendWarranty: null,
    warrantyStatusId: null,
    serviceOfferingAddOnId: null,
    servicePriceLevelId: null,
    siteId: null,
    warrantyEndDate: null,
  },
  siteData: {
    siteId: null,
    psSiteCode: null,
    siteName: null,    
  },
  // fetch copied email details
  quoteDetailsForCopyEmail:[], 
  // loading for fetching copy email details
  quoteDetailsForCopyEmailLoading:false,
// confirms sent email response
  notificationSentCopy:null,
  // tracks loading of email sending
  notificationSentLoadingCopy:false,
  // response of sent copy email api 
  sentCopiedResponse:[],
  //Set Customer If for Existing Quotes
  custIdExistingQuotes: '',
  custNameExistingQuotes: '',
  isCustomerETrackExistingQuote: false,
  siteSyncFlag: false,
  isQuoteGridDataChange: false,
  eTrackSearchPage: 0,
  isResetClicked:false,
  rowsPerPage: GRID_ROWS_PER_PAGE.eTrackSearchSourceGrid,
  eosModelName: null,
  eosDate: null,
  isMultipleSitesSiteSync: false,
  isNewWarrantyEndDateEmpty: false,
  siteTypeData: [],
  quoteItemExist: false,
  existItemQuoteIds: [],
  siteSyncNoSiteSelectedFlag: false,
  listOfMCN: null,
  listOfMCNUpdated: false,
};
